import type { RootState } from 'APP/Store/CreateStore'
import { MemberTasksRequestState, MemberTasksState, MemberTask } from './types'

const EMPTY_REQUEST: MemberTasksRequestState = {
  isLoading: false,
  isRefreshing: false,
  error: null,
  lastFetchedAt: null,
}

const EMPTY_LIST: MemberTask[] = []
const EMPTY_STATE: MemberTasksState = { episodeId: null, list: EMPTY_LIST, request: EMPTY_REQUEST }

const selectMemberTasksState = (state: RootState) => state.memberTasks ?? EMPTY_STATE

const selectIsFeatureEnabled = (state: RootState) => state.features?.enableEpisodeNextTasks === true

export const selectMemberTasksRequestState = (
  state: RootState,
  episodeId: string
): MemberTasksRequestState => {
  const tasks = selectMemberTasksState(state)
  return tasks.episodeId === episodeId ? tasks.request : EMPTY_REQUEST
}

export const selectEpisodeMemberTasks = (state: RootState, episodeId: string): MemberTask[] => {
  if (!selectIsFeatureEnabled(state)) return EMPTY_LIST
  const tasks = selectMemberTasksState(state)
  return tasks.episodeId === episodeId ? tasks.list : EMPTY_LIST
}
